import { render, staticRenderFns } from "./GoodsBatchFaKa.vue?vue&type=template&id=103012c0&scoped=true&"
import script from "./GoodsBatchFaKa.vue?vue&type=script&lang=js&"
export * from "./GoodsBatchFaKa.vue?vue&type=script&lang=js&"
import style0 from "./GoodsBatchFaKa.vue?vue&type=style&index=0&id=103012c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103012c0",
  null
  
)

export default component.exports